import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// This service is strictly for sharing data between certain parent/child elements.
// For example, you cannot directly bind data to a <router-outlet> tag. If a parent component
// loads data and wants to pass it to it's children, it should be done through this service.
// It IS possible to pass data from parent to child component using an event that is fired when the
// router outlet is activated.
@Injectable()
export class SharedDataService {
  constructor() {}

  // Event source is responsible for sending 'events' between parent/child components.
  // Events can trigger functions on parent/child. All events require a name. Data is optional.
  private eventSource = new Subject<any>();

  listenForEvent<Type>(): Observable<{ eventName: string; data?: Type }> {
    return this.eventSource.asObservable();
  }

  sendEvent<Type>(eventName: string, data?: Type) {
    this.eventSource.next({ eventName, data });
  }

  /*
  setReloadFunction(fn: Function, params: any[] = []) {
    this.reloadFunction = fn;

    if (params) {
      this.reloadFunctionParamsArray = params;
    }
  }

  reloadData() {
    if (this.reloadFunction && this.reloadFunctionParamsArray) {
      this.reloadFunction(...this.reloadFunctionParamsArray)
    }
  }
  */
}
